import { render } from "./RdPagination.vue?vue&type=template&id=31bd69e6&scoped=true&ts=true"
import script from "./RdPagination.vue?vue&type=script&lang=ts"
export * from "./RdPagination.vue?vue&type=script&lang=ts"

import "./RdPagination.vue?vue&type=style&index=0&id=31bd69e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bd69e6"]])

export default __exports__